import React, { Fragment, useState, useContext, useEffect } from "react";
import Supporttype from "./Supporttype";
import Searchbykeyword from "./Searchbykeyword";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ramactions } from "../store/index";
import { useTranslation } from "react-i18next";
const Searchtype = (props) => {
  const { t } = useTranslation("translation", { keyPrefix: "searchType" });
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [issupporttypevisible, setIssupporttypevisible] = useState(false);
  const [iskeywordvisible, setIskeywordvisible] = useState(false);
  const [displaysearchresult, setDisplaysearchresult] = useState(false);
  const [selectedtype, setSelectedtype] = useState("topic");
  const [siteLang, setSiteLang] = useState('en');
  const isDisplayresult = useSelector((index) => index.isDisplayresult);
  const searchBy = useSelector((index) => index.searchBy);
  const dispatch = useDispatch();

  useEffect(() => {
    /*if (queryParams.has("type")) {
      queryParams.delete("type");
    }
    history.replace({
      search: queryParams.toString() + "&type=" + searchBy,
    });*/
    if (searchBy === "topic") {
      setIssupporttypevisible(true);
      setIskeywordvisible(false);
    } else {
      setIssupporttypevisible(false);
      setIskeywordvisible(true);
    }
    if (document.documentElement.lang === 'en-US') {
      setSiteLang('en');
    } else if (document.documentElement.lang === 'fr-FR') {
      setSiteLang('fr');
    }
  }, []);
  const searchbyhanddler = (e) => {
    dispatch(ramactions.updateSeachBy(e.target.value));
    dispatch(ramactions.updateCategory(0));
    dispatch(ramactions.updatesubCategory(0));
    dispatch(ramactions.updateKeyword(''));
    if (queryParams.has("type")) {
      queryParams.delete("type");
    }
    if (queryParams.has("subcategory")) {
      queryParams.delete("subcategory");
    }
    if (queryParams.has("category")) {
      queryParams.delete("category");
    }
    if (queryParams.has("keyword")) {
      queryParams.delete("keyword");
    }

    if (queryParams.has("resourceType")) {
      queryParams.delete("resourceType");
    }
    if (queryParams.has("languages")) {
      queryParams.delete("languages");
    }
    if (queryParams.has("communities")) {
      queryParams.delete("communities");
    }
    if (queryParams.has("accessibilities")) {
      queryParams.delete("accessibilities");
    }
    if (queryParams.has("costs")) {
      queryParams.delete("costs");
    }
    history.replace({
      search: queryParams.toString() + "&type=" + e.target.value,
    });
  };

  const onChangesupporttypehanddler = (currentval) => {
    setDisplaysearchresult(currentval);
    props.onSearchtypeChange(currentval);
  };

  const onChangekeywordhanddler = (currentval) => {
    setDisplaysearchresult(currentval);
    props.onSearchtypeChange(currentval);
  };

  const staticURL = {
    en: {
      search_tips: "/resources-around-me/search-tips/",
      faq: "/resources-around-me/faq/"
    },
    fr: {
      search_tips: "/ressources-autour-de-moi/astuces/",
      faq: " /ressources-autour-de-moi/faq/"
    }
  }
  return (
    <Fragment>
      <div className="container">
        <div className="row">
          {!isDisplayresult && (
            <div className="col-xl-4 offset-xl-4 col-lg-6 offset-lg-3 col-md-8 offset-md-2 animate__animated animate__fadeInUp">
              <div className="form-group">
                <div className="d-flex justify-content-between">
                  <label className="label">{t("search_by_label")}</label>
                  <a
                    href={siteLang === 'en' ? staticURL.en.search_tips : staticURL.fr.search_tips}
                    className="ext-link"
                  >
                    {t("search_tips_link")}

                  </a>
                </div>
                <div className="switch-container">
                  <div className="radio-group" role="radiogroup">
                    <input
                      type="radio"
                      name="search_by"
                      value="topic"
                      id="search_by_topic"
                      onClick={searchbyhanddler}
                      checked={searchBy === "topic" ? "checked" : ""}
                    />
                    <label for="search_by_topic">{t("support_type__radio_label")}</label>
                    <input
                      type="radio"
                      name="search_by"
                      value="keyword"
                      id="search_by_keyword"
                      onClick={searchbyhanddler}
                      checked={searchBy === "keyword" ? "checked" : ""}
                    />
                    <label for="search_by_keyword">{t("keyword__radio_label")}</label>
                    <span class="selection-indicator"></span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {searchBy === "topic" && (
        <Supporttype
          onChangesupporttype={onChangesupporttypehanddler}
          backToHome={props.goToHome}
        />
      )}
      {searchBy === "keyword" && (
        <Searchbykeyword
          onChangekeyword={onChangekeywordhanddler}
          backToHome={props.goToHome}
        />
      )}
    </Fragment>
  );
};

export default Searchtype;
